/**
 * An API error as a sentence in the interface's language (errorMessage), and
 * what support needs folded away under Details: the code, the API's own
 * detail and the request's reference (docs/help/errors.md, rule 3).
 *
 * The detail is English written for developers. In English it already is the
 * sentence for any code without catalog copy, so Details appears only in
 * another language, where the detail would otherwise be lost: a create form
 * that names the missing field in English still names it, one click away.
 */
import { errorMessage, useTranslation } from "@/lib/i18n";

interface ErrorFields {
  code?: unknown;
  detail?: unknown;
  message?: unknown;
  requestId?: unknown;
}

const text = (value: unknown): string =>
  typeof value === "string" ? value : "";

export function ErrorText({ error }: { error: unknown }) {
  const { t, i18n } = useTranslation();
  const e = (error ?? {}) as ErrorFields;
  const support = [
    text(e.code),
    text(e.detail) || text(e.message),
    text(e.requestId),
  ].filter(Boolean);
  return (
    <>
      {errorMessage(error, t, i18n.language)}
      {i18n.language !== "en" && support.length > 0 && (
        <details style={{ marginBlockStart: 4 }}>
          <summary>{t("common.details")}</summary>
          <bdi lang="en" dir="ltr" className="atlas-mono">
            {support.join(" · ")}
          </bdi>
        </details>
      )}
    </>
  );
}
